'use client';

import { Accordion } from '@flipster/features/src/shared/faq-accordion';
import { css } from '@flipster/styled-system/css';
import segment, { marketingEventEvent } from '@flipster/utils/segment';

import type { FaqItemFragment } from '@web/app/[locale]/campaign/[slug]/query.generated';
import { sectionInnerLayoutCssRaw } from '@web/app/[locale]/campaign/[slug]/styles';
import ContentfulRichText from '@web/components/ContentfulRichText';

interface FaqProps {
  faqs?: (FaqItemFragment | null)[];
}

export const Faq = ({ faqs }: FaqProps) => {
  if (!faqs?.length) return null;

  return (
    <section data-section-type='faq'>
      <div className={css(sectionInnerLayoutCssRaw)}>
        <h2
          className={css({
            textStyle: 'Display/XL',
            color: 'content.default.level-4',
            textAlign: { base: 'center', tablet: 'left' },
          })}
        >
          Frequently asked questions
        </h2>
        <Accordion.Root headingLevel={3} css={{ mt: { base: 32, tablet: 40 } }}>
          {faqs.map((faq, index) => {
            if (!faq) return null;
            return (
              <Accordion.Item key={faq.sys.id}>
                <Accordion.Header
                  index={index + 1}
                  onExpanded={() =>
                    segment.track(marketingEventEvent.faqOpen, {
                      faq_title: faq.title ?? 'unknown',
                      list_order: index,
                    })
                  }
                >
                  {faq.title}
                </Accordion.Header>
                <Accordion.Panel>
                  {faq.description && <ContentfulRichText richTextDocument={faq.description} />}
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion.Root>
      </div>
    </section>
  );
};
